import Card from 'react-bootstrap/Card';
import './projectCard.css'
import Button from '../../Shared/Button';

import FishPopup from '../../FishPopup';
import React, { useState } from 'react';


const ProjectCard = ({ image, title, description }) => {

  const [showModal, setShowModal] = useState(false);

  const renderDescription = () => {
    if (description.length > 135) {
      const truncatedDescription = description.slice(0, 135) + '...';
      return <div dangerouslySetInnerHTML={{ __html: truncatedDescription }} />;
    }
    return <div dangerouslySetInnerHTML={{ __html: description }} />;
  };

  const handleClose = () => setShowModal(false);

  return (

    <Card className='cardBox' >
      <Card.Img className='cardImage' variant="top" src={image ? image : "https://cdn2.vectorstock.com/i/1000x1000/88/26/no-image-available-icon-flat-vector-25898826.jpg"} />
      <div className='bodyC'>
        <Card.Body className='cardBody'>
          <Card.Title className='cardTitle'>{title}</Card.Title>
          <Card.Text >
            {renderDescription()}
          </Card.Text>
          <div className='view-project-button-container'>
            <Button buttonStyle='pink' text='View Project' navigateTo={`/project/${title}`} />
          </div>
        </Card.Body>
      </div>
    </Card>
  );
}

export default ProjectCard;